// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"AutoCompleteAdress_dropdown__CdyvK","dropdown__item":"AutoCompleteAdress_dropdown__item__hsisb"};